import { render } from "./Sherryweek.vue?vue&type=template&id=642ac02e&scoped=true"
import script from "./Sherryweek.vue?vue&type=script&lang=js"
export * from "./Sherryweek.vue?vue&type=script&lang=js"

import "./Sherryweek.vue?vue&type=style&index=0&id=642ac02e&scoped=true&lang=css"

import exportComponent from "/Users/ward/Projects/Chelsea/sherryV2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642ac02e"]])

export default __exports__